import {FC} from 'react'
import classNames from 'classnames'
import {DOCUMENT_VISIVILITIES} from 'consts/document'
import {fullNameFormat, displayFormat, dateFormat} from 'libs/formatter'
import Loading from 'components/Loading'
import {ColorLabel} from 'components/ui/ColorLabel'
import {SearchResult} from 'components/ui/SearchResult'
import {PerPage} from 'components/ui/PerPage'
import {CreatedUser, Document} from '../query'
import styles from './ContractTargetList.scss'

const VISIBILITIY_COLOR_MAP = {
  all_admins: 'green',
  private: 'blue',
} as const

const fullName = (createdUser?: CreatedUser) => {
  if (createdUser) {
    if (createdUser.employee) {
      const {displayLastName, displayFirstName} = createdUser.employee
      return fullNameFormat(displayLastName, displayFirstName)
    }

    return createdUser.email
  }

  return displayFormat()
}

interface ContractTargetListProps {
  documents?: {
    totalCount: number
    list: Document[]
  }
  loading: boolean
  per: number
  page: number
  setPerPage: (per: number) => void
}

export const ContractTargetList: FC<ContractTargetListProps> = ({documents, loading, per, page, setPerPage}) => {
  return (
    <div className="u-mb30">
      <h4 className={classNames('u-mb10', styles.summaryHeader)}>送信対象書類</h4>

      <div className={styles.pagerArea}>
        <PerPage options={[10, 20, 50, 99]} selected={per} onChange={(per) => setPerPage(per)} />

        {documents && documents?.totalCount > 0 && (
          <SearchResult total={documents.totalCount} limit={per} page={page} />
        )}
      </div>

      <div className="l-overflow-scroll">
        <table className={`m-table-list m-table-fixed`}>
          <thead>
            <tr>
              <th className={styles.createdAtColumn}>作成日</th>
              <th className={styles.titleColumn}>書類名</th>
              <th className={styles.visibilityColumn}>閲覧範囲</th>
              <th className={styles.createdUserColumn}>作成者</th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              documents?.list.map((document) => (
                <tr key={document.id}>
                  <td>{dateFormat(document.createdAt, 'YYYY/MM/DD')}</td>
                  <td>{displayFormat(document.title)}</td>
                  <td>
                    <ColorLabel color={VISIBILITIY_COLOR_MAP[document.visibility]}>
                      {DOCUMENT_VISIVILITIES[document.visibility]}
                    </ColorLabel>
                  </td>
                  <td>{fullName(document.createdUser)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {loading && <Loading />}
    </div>
  )
}
